<template>
  <section @click="set(item)">
    <div class="info-userelement">
      <template v-if="isDeletedUser">
        <span class="info-username">{{ getUserInfoById(getItem.userId).userName }}</span>
      </template>
      <template v-else>
        <router-link @click.prevent :to="{ name: 'User', params: { userId: getItem.userId }}">
          <span class="info-username">{{ getUserInfoById(getItem.userId).userName }}</span>
        </router-link>
      </template>
      <span class="info-time">
        <span>{{ getItem.createdAt | preparedTime }}</span>
      </span>
    </div>
    <read-more :targetId="this.getItemId" :text="this.getItem.contentText" :addMore="this.detailView" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
      {{ this.getItem.contentText }}
    </read-more>
    <image-viewer v-if="getItem.uploadedFile" :uploadedFile="getItem.uploadedFile" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import ImageViewer from '@/components/Fb/ImageViewer'

export default {
  name: 'FbItem',
  props: {
    item: {
      type: Object
    },
    itemId: String,
    isDeletedUser: Boolean,
    useIcon: '',
    detailView: {
      type: Boolean
    }
  },
  components: {
    ReadMore,
    ImageViewer
  },
  data () {
    return {
      options: {
        showCounter: false,
        widthRatio: 0.5,
        heightRatio: 0.5,
        nav: false,
        enableKeyboard: false,
        overlay: false,
        close: false
      },
      propShowMore: false,
      propContentHeight: 0
    }
  },
  computed: {
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getItem: function () {
      return this.item
    },
    getItemId: function () {
      return this.itemId
    },
    getImages: function () {
      return [{src: this.getItem.uploadedFile, title: ''}]
    }
  },
  methods: {
    set: function (value) {
      console.log('FbItem:set', value)
      this.$emit('get-feed', value)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fb/FbItem.vue